import type { Command } from "../types";
import { EventEmitter } from "./EventEmitter";

export class CommandManager {
    private history: Command[] = [];
    private currentIndex: number = -1;
    private readonly emitter = new EventEmitter();

    execute(command: Command): void {
        // Remove any commands after current index
        this.history = this.history.slice(0, this.currentIndex + 1);

        command.execute();
        this.history.push(command);
        this.currentIndex++;
        this.emitter.emit('historyChanged');
    }

    undo(): void {
        if (this.canUndo()) {
            const command = this.history[this.currentIndex];
            command.undo();
            this.currentIndex--;
            this.emitter.emit('historyChanged');
        }
    }

    redo(): void {
        if (this.canRedo()) {
            this.currentIndex++;
            const command = this.history[this.currentIndex];
            command.execute();
            this.emitter.emit('historyChanged');
        }
    }

    canUndo(): boolean {
        return this.currentIndex >= 0;
    }

    canRedo(): boolean {
        return this.currentIndex < this.history.length - 1;
    }

    on(event: 'historyChanged', callback: () => void): void {
        this.emitter.on(event, callback);
    }
}
